<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1>{{$t("message.account.entry.title.account")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12" md="8">
        <mp-error :errors="view.errors" :replaceList="errMessageReplaceList" message-key="message.account.entry.error." />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8" class="text-right">
        <span class="red--text">※</span>{{$t("message.account.entry.desc.text1")}}
      </v-col>
    </v-row>

    <!-- ID -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.id")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.id"
          v-bind:placeholder="$t('message.account.entry.ph.id')"
          id="id"
          hide-details
          solo
          maxlength="100"
          required
          validate-on-blur
        ></v-text-field>
        <div class="descIdContainer">
          <p class="descId">{{$t("message.account.entry.desc.id")}}</p>
        </div>
      </v-col>
    </v-row>

    <!-- 氏名 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.name")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.name"
          v-bind:placeholder="$t('message.account.entry.ph.name')"
          id="name"
          hide-details
          solo
          maxlength="50"
          required
          validate-on-blur
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 所属 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.group")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-row>
          <v-col class="pr-3" cols="12">
            <div class="text-right">
              <mp-button @click="dialog.seachCompany = true">{{$t("message.account.entry.button.searchCompany")}}</mp-button>
            </div>
            <mp-search-company-dialog
            :show="dialog.seachCompany"
            :only-account-entry-group="true"
            @change-show="dialog.seachCompany = $event"
            @select-company="selectCompany"
            />
          </v-col>
        </v-row>
        <v-row v-for="(item, index) in getGroupList"
          :key="item.groupLargeId"
        >
          <v-col class="pa-1 pl-3" cols="6">
            <v-radio-group v-model="form.groupLargeId" class="mt-0">
                <v-radio
                :label="item.groupLargeName[$i18n.locale]"
                :value="item.groupLargeId"
                :id="`groupLargeId-${item.groupLargeId}`"
                hide-details
                dense
                @change="changeGroupLarge(item.groupLargeId, item.companyInsNoFlg)"
                />
            </v-radio-group>
          </v-col>
          <v-col class="py-1 pr-3" md="6">
              <v-select
              v-model="form.groupSmallId"
              :items="view.groupList[index].groupSmallList"
              :label="$t('message.account.entry.ph.groupSmall')"
              :item-text="getGroupSmallName"
              item-value="groupSmallId"
              :id="`groupSmallId-${item.groupLargeId}`"
              hide-details
              solo
              dense
              :disabled="form.groupLargeId !== item.groupLargeId"
              @change="(groupSmallId) => changeGroupSmall(groupSmallId, item.companyInsNoFlg)"
              ></v-select>
            </v-col>

          </v-row>
      </v-col>
    </v-row>

    <!-- 会社 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{view.companyLabel[$i18n.locale]}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1'">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
          <v-select
            v-model="form.companyId"
            :items="view.companyList"
            :label="$t('message.account.entry.ph.companyId')"
            item-text="companyName"
            item-value="companyId"
            :disabled="view.companyList.length === 0 || view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg === '1'"
            id="companyId"
            hide-details
            solo
            dense
            @change="changeCompany"
          ></v-select>
          <v-text-field
            v-if="form.companyId === constantValue.otherCompanyId"
            v-model="form.companyName"
            v-bind:placeholder="$t('message.account.entry.ph.companyName').replace('##COMPANY_LABEL##', view.companyLabel[$i18n.locale])"
            id="companyName"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
          <v-text-field
            v-if="$i18n.locale === 'ja' && form.companyId === constantValue.otherCompanyId"
            v-model="form.companyNameKana"
            v-bind:placeholder="$t('message.account.entry.ph.companyNameKana').replace('##COMPANY_LABEL##', view.companyLabel[$i18n.locale])"
            id="companyNameKana"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
      </v-col>
    </v-row>

    <!-- 支社・支局または媒体 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{view.branchLabel[$i18n.locale]}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1' && view.branchList.length > 1">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
          <v-select
            v-model="form.branchId"
            :items="view.branchList"
            :label="$t('message.account.entry.ph.branch').replace('##BRANCH_LABEL##', view.branchLabel[$i18n.locale])"
            item-text="branchName"
            item-value="branchId"
            :disabled="view.branchList.length === 0 || view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg === '1'"
            id="branchId"
            hide-details
            solo
            dense
            @change="changeBranch"
          ></v-select>
          <v-text-field
            v-if="form.branchId === constantValue.otherBranchId"
            v-model="form.branchName"
            v-bind:placeholder="$t('message.account.entry.ph.branchName').replace('##BRANCH_LABEL##', view.branchLabel[$i18n.locale])"
            id="branchName"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
          <v-text-field
            v-if="$i18n.locale === 'ja' && form.branchId === constantValue.otherBranchId"
            v-model="form.branchNameKana"
            v-bind:placeholder="$t('message.account.entry.ph.branchNameKana').replace('##BRANCH_LABEL##', view.branchLabel[$i18n.locale])"
            id="branchNameKana"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
      </v-col>
    </v-row>

    <!-- 郵便番号 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.postNo")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.postNo"
          hide-details
          v-bind:placeholder="$t('message.account.entry.ph.postNo')"
          id="postNo"
          solo
          dense
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 都道府県 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.prefCd")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
          <v-select
            v-model="form.prefCd"
            :items="$store.getters.prefCodeList"
            :item-text="getPrefName"
            item-value="kbnCd"
            :label="$t('message.account.entry.ph.prefCd')"
            id="prefCd"
            hide-details
            dense
            solo
          ></v-select>
      </v-col>
    </v-row>

    <!-- 市区町村 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.addr1")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.addr1"
          v-bind:placeholder="$t('message.account.entry.ph.addr1')"
          id="addr1"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 番地 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.addr2")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.addr2"
          v-bind:placeholder="$t('message.account.entry.ph.addr2')"
          id="addr2"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- ビル名 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.addr3")}}</mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.addr3"
          v-bind:placeholder="$t('message.account.entry.ph.addr3')"
          id="addr3"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 部署 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.busho")}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1'">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.busho"
          v-bind:placeholder="$t('message.account.entry.ph.busho')"
          id="busho"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 電話番号 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.telNo")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.telNo"
          v-bind:placeholder="$t('message.account.entry.ph.telNo')"
          id="telNo"
          hide-details
          dense
          solo
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 備考 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.remarks")}}</mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-textarea
          v-model="form.remarks"
          v-bind:placeholder="$t('message.account.entry.ph.remarks')"
          id="remarks"
          hide-details
          dense
          solo
          rows="8"
          maxlength="20000"
        ></v-textarea>
      </v-col>
    </v-row>

    <!-- 利用希望サービス -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.services")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-checkbox v-for="(item) in view.serviceList"
          :key="item.serviceId"
          v-model="form.services"
          :label="item.serviceName[$i18n.locale]"
          :value="item.serviceId"
          :id="`serviceId-${item.serviceId}`"
          :disabled="!(item.groupLargeIdList.includes(form.groupLargeId) && item.groupSmallIdList.includes(form.groupSmallId))"
          hide-details
          dense
          class="my-2 py-0"
        >
        </v-checkbox>
        <p />
        <p>{{$t("message.account.entry.desc.serviceText")}}</p>
      </v-col>
    </v-row>

    <!-- フリーランス申請 start -->
    <template v-if="isFreelance">
      <v-row justify="center">
        <v-col cols="12" md="8">
          <h1 class="mt-5">{{$t("message.account.entry.title.freelance")}}</h1>
        </v-col>
      </v-row>

      <!-- 推薦社名 -->
      <v-row justify="center">
        <v-col cols="4" md="2">
          <mp-label>{{$t("message.account.entry.label.recommendationCompanyName")}}<span class="red--text">※</span></mp-label>
        </v-col>
        <v-col cols="8" md="6">
          <v-text-field
            v-model="freelanceForm.recommendationCompanyName"
            v-bind:placeholder="$t('message.account.entry.ph.recommendationCompanyName')"
            id="freelance-recommendationCompanyName"
            hide-details
            solo
            maxlength="100"
            required
            validate-on-blur
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- 推薦媒体名 -->
      <v-row justify="center">
        <v-col cols="4" md="2">
          <mp-label>{{$t("message.account.entry.label.recommendationMediaName")}}<span class="red--text">※</span></mp-label>
        </v-col>
        <v-col cols="8" md="6">
          <v-text-field
            v-model="freelanceForm.recommendationMediaName"
            v-bind:placeholder="$t('message.account.entry.ph.recommendationMediaName')"
            id="freelance-recommendationMediaName"
            hide-details
            solo
            maxlength="100"
            required
            validate-on-blur
          ></v-text-field>
        </v-col>
      </v-row>

    <!-- 媒体内容 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.mediaContents")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-textarea
          v-model="freelanceForm.mediaContents"
          v-bind:placeholder="$t('message.account.entry.ph.mediaContents')"
          id="freelance-mediaContents"
          hide-details
          dense
          solo
          rows="8"
          maxlength="20000"
        ></v-textarea>
      </v-col>
    </v-row>

    <!-- 媒体発行詳細 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.mediaIssueDetail")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-textarea
          v-model="freelanceForm.mediaIssueDetail"
          v-bind:placeholder="$t('message.account.entry.ph.mediaIssueDetail')"
          id="freelance-mediaIssueDetail"
          hide-details
          dense
          solo
          rows="8"
          maxlength="20000"
        ></v-textarea>
      </v-col>
    </v-row>

    <!-- 推薦責任者名 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.recommendationResponsibleName")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="freelanceForm.recommendationResponsibleName"
          v-bind:placeholder="$t('message.account.entry.ph.recommendationResponsibleName')"
          id="freelance-recommendationResponsibleName"
          hide-details
          solo
          maxlength="100"
          required
          validate-on-blur
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 推薦責任者メールアドレス -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.recommendationResponsibleMailAddress")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="freelanceForm.recommendationResponsibleMailAddress"
          v-bind:placeholder="$t('message.account.entry.ph.recommendationResponsibleMailAddress')"
          id="freelance-recommendationResponsibleMailAddress"
          hide-details
          solo
          maxlength="100"
          required
          validate-on-blur
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 推薦理由 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.recommendationReason")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-textarea
          v-model="freelanceForm.recommendationReason"
          v-bind:placeholder="$t('message.account.entry.ph.recommendationReason')"
          id="freelance-recommendationReason"
          hide-details
          dense
          solo
          rows="8"
          maxlength="20000"
        ></v-textarea>
      </v-col>
    </v-row>

    <!-- 取材活動実績 -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label>{{$t("message.account.entry.label.trackRecord")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <div>
          <v-textarea
            v-model="freelanceForm.trackRecord"
            v-bind:placeholder="$t('message.account.entry.ph.trackRecord')"
            id="freelance-trackRecord"
            hide-details
            dense
            solo
            rows="8"
            maxlength="20000"
          ></v-textarea>
        </div>
        <div class="mt-5">
          <v-row v-if="view.freelanceFileErrors.length > 0">
            <v-col cols="12" md="8">
              <mp-error :errors="view.freelanceFileErrors" message-key="message.account.entry.error." :scroll="false"/>
            </v-col>
          </v-row>
          <mp-button
            @click="$refs.freelanceFile.click()">
            {{ $t('message.account.entry.button.fileAttachment') }}
          </mp-button>
          <input
            type="file"
            style="display: none"
            ref="freelanceFile"
            @change="freelanceFileUpload"
          >
          <div class="mt-3">
            <p class="mb-2">{{ $t('message.account.entry.desc.fileExt') }}</p>
            <p class="mb-2">{{ $t('message.account.entry.desc.fileSize') }}</p>
          </div>
        </div>
        <div class="mt-5">
          <div v-for="file in freelanceForm.uploadFiles" :key="file.path">
            <p class="mb-2">
              <span class="fileName">{{ file.name }}</span>
              <span class="fileDelete" @click="freelanceFileDelete(file)">×</span>
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
    </template>
    <!-- フリーランス申請 end -->

    <!-- ローカル媒体申請 start -->
    <template v-if="isNewLocalMedia">
      <v-row justify="center">
        <v-col cols="12" md="8">
          <h1 class="mt-5">{{$t("message.account.entry.title.localMedia")}}</h1>
        </v-col>
      </v-row>

      <!-- 媒体発行詳細 -->
      <v-row justify="center">
        <v-col cols="4" md="2">
          <mp-label>{{$t("message.account.entry.label.mediaIssueDetail")}}<span class="red--text">※</span></mp-label>
        </v-col>
        <v-col cols="8" md="6">
          <v-textarea
            v-model="localMediaForm.mediaIssueDetail"
            v-bind:placeholder="$t('message.account.entry.ph.mediaIssueDetail')"
            id="localMedia-mediaIssueDetail"
            hide-details
            dense
            solo
            rows="8"
            maxlength="20000"
          ></v-textarea>
        </v-col>
      </v-row>

      <!-- 媒体カバーエリア -->
      <v-row justify="center">
        <v-col cols="4" md="2">
          <mp-label>{{$t("message.account.entry.label.mediaCoverageArea")}}<span class="red--text">※</span></mp-label>
        </v-col>
        <v-col cols="8" md="6">
          <v-textarea
            v-model="localMediaForm.mediaCoverageArea"
            v-bind:placeholder="$t('message.account.entry.ph.mediaCoverageArea')"
            id="localMedia-mediaCoverageArea"
            hide-details
            dense
            solo
            rows="8"
            maxlength="20000"
          ></v-textarea>
        </v-col>
      </v-row>

      <!-- グループ責任者名 -->
      <v-row justify="center">
        <v-col cols="4" md="2">
          <mp-label>{{$t("message.account.entry.label.groupResponsibleName")}}<span class="red--text">※</span></mp-label>
        </v-col>
        <v-col cols="8" md="6">
          <v-text-field
            v-model="localMediaForm.groupResponsibleName"
            v-bind:placeholder="$t('message.account.entry.ph.groupResponsibleName')"
            id="localMedia-groupResponsibleName"
            hide-details
            solo
            maxlength="100"
            required
            validate-on-blur
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- 利用者名 -->
      <v-row justify="center">
        <v-col cols="4" md="2">
          <mp-label>{{$t("message.account.entry.label.userName")}}<span class="red--text">※</span></mp-label>
        </v-col>
        <v-col cols="8" md="6">
          <v-textarea
            v-model="localMediaForm.userName"
            v-bind:placeholder="$t('message.account.entry.ph.userName')"
            id="localMedia-userName"
            hide-details
            dense
            solo
            rows="8"
            maxlength="20000"
          ></v-textarea>
        </v-col>
      </v-row>

      <!-- ローカル媒体管理クラブ -->
      <v-row justify="center">
        <v-col cols="4" md="2">
          <mp-label>{{$t("message.account.entry.label.localMediaManagementClub")}}<span class="red--text">※</span></mp-label>
        </v-col>
        <v-col cols="8" md="6">
            <v-select
              v-model="localMediaForm.localMediaManagementClub"
              :items="localMediaManagementClubCodeList"
              :item-text="getLocalMediaManagementClubName"
              item-value="kbnCd"
              :label="$t('message.account.entry.ph.localMediaManagementClub')"
              id="localMedia-localMediaManagementClub"
              hide-details
              dense
              solo
              multiple
              chips
            ></v-select>
        </v-col>
      </v-row>

      <!-- その他 -->
      <v-row justify="center">
        <v-col cols="4" md="2">
          <mp-label>{{$t("message.account.entry.label.other")}}</mp-label>
        </v-col>
        <v-col cols="8" md="6">
          <v-textarea
            v-model="localMediaForm.other"
            v-bind:placeholder="$t('message.account.entry.ph.other')"
            id="localMedia-other"
            hide-details
            dense
            solo
            rows="8"
            maxlength="20000"
          ></v-textarea>
        </v-col>
      </v-row>
    </template>
    <!-- ローカル媒体申請 end -->

    <!-- 利用規約 -->
    <v-row justify="center">
      <v-col cols="12" md="6" offset-md="2">
        <v-checkbox
          v-model="view.acceptTerms"
          class="acceptTermsOfUse"
        >
          <template v-slot:append>
            <span>
              {{$t("message.account.entry.desc.acceptTermsOfUse1")}}
              <router-link
                :to="{ path: '/account/terms-of-use', query: { lang: $i18n.locale } }"
                target="_blank"
              >
                {{$t("message.account.entry.desc.openTermsOfUse")}}
              </router-link>
              {{$t("message.account.entry.desc.acceptTermsOfUse2")}}
            </span>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>

    <v-row justify="center">
      <!-- 戻るボタン -->
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goLogin">{{ $t('message.account.entry.button.back') }}</mp-button>
      </v-col>
      <!-- 申請ボタン -->
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button
          wide
          :disabled="!view.acceptTerms"
          :disabledBtn="!view.acceptTerms"
          @click="beforeRegister">{{ $t('message.account.entry.button.entry') }}
        </mp-button>
        <form-confirm :show="dialog.inputConfirm" :optionForm="form"
            :optionfreelanceForm="isFreelance ? freelanceForm : null"
            :optionLocalMediaForm="isNewLocalMedia ? localMediaForm : null"
            :group="view.groupList" :company="view.companyList" :branch="view.branchList" :service="view.serviceList"
            :companyLabel="view.companyLabel" :branchLabel="view.branchLabel"
            @clickOk="goRegister" @clickCancel="dialog.inputConfirm = false"/>
        <mp-dialog entry :show="dialog.entryComplete" @clickOk="goLogin" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import i18n from '@/message'
import MpLabel from '@/components/item/MpLabel.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import MpSearchCompanyDialog from '@/components/item/MpSearchCompanyDialog.vue'
import { AccountEntry, Common } from '@/api'
import constantValue from '@/constantValue'
import MpError from '@/components/item/MpError.vue'
import FormConfirm from './EntryConfirm.vue'
import StringUtils from '@/utils/StringUtil'

export default {
  name: 'AccountEntry',
  components: {
    MpError,
    MpLabel,
    MpButton,
    MpDialog,
    MpSearchCompanyDialog,
    FormConfirm
  },
  data: () => ({
    constantValue: constantValue,
    view: {
      companyDefaultLabel: {
        ja: '',
        en: ''
      },
      branchDefaultLabel: {
        ja: '',
        en: ''
      },
      companyLabel: {
        ja: '',
        en: ''
      },
      branchLabel: {
        ja: '',
        en: ''
      },
      groupList: [],
      companyList: [],
      branchList: [],
      serviceList: [],
      errors: [],
      acceptTerms: false,
      freelanceFileErrors: []
    },
    form: {
      id: '',
      name: '',
      groupLargeId: '',
      companyInsNoFlg: '',
      groupSmallId: '',
      companyId: '',
      companyName: '',
      companyNameKana: '',
      branchId: '',
      branchName: '',
      branchNameKana: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: [],
      locale: '',
      freelance: null,
      localMedia: null
    },
    freelanceForm: {
      recommendationCompanyName: '',
      recommendationMediaName: '',
      mediaContents: '',
      mediaIssueDetail: '',
      recommendationResponsibleName: '',
      recommendationResponsibleMailAddress: '',
      recommendationReason: '',
      trackRecord: '',
      uploadFiles: []
    },
    localMediaForm: {
      mediaIssueDetail: '',
      mediaCoverageArea: '',
      groupResponsibleName: '',
      userName: '',
      localMediaManagementClub: [],
      other: ''
    },
    dialog: {
      inputConfirm: false,
      entryComplete: false,
      seachCompany: false
    },
    errMessageReplaceList: []
  }),
  computed: {
    getGroupList () {
      return this.view.groupList
    },
    isFreelance () {
      const group = this.view.groupList.find(g => g.groupLargeId === this.form.groupLargeId)
      return group && group.freelanceFlg === '1'
    },
    isNewLocalMedia () {
      const groupLarge = this.view.groupList.find(g => g.groupLargeId === this.form.groupLargeId)
      if (!groupLarge) return false
      const groupSmall = groupLarge.groupSmallList.find(g => g.groupSmallId === this.form.groupSmallId)
      return groupSmall && groupSmall.localMediaFlg === '1' && this.form.companyId === this.constantValue.otherCompanyId
    },
    localMediaManagementClubCodeList () {
      return this.$store.getters.localMediaManagementClubCodeList
    }
  },
  methods: {
    async loadViewData () {
    },
    initCompanyList (otherOnlyFlg = false) {
      // 一覧および入力・選択情報を初期化
      if (!otherOnlyFlg) {
        this.view.companyList = []
        this.form.companyId = null
      }
      this.form.companyName = ''
      this.form.companyNameKana = ''
    },
    initBranchList (otherOnlyFlg = false) {
      // 一覧および入力・選択情報を初期化
      if (!otherOnlyFlg) {
        this.view.branchList = []
        this.form.branchId = null
      }
      this.form.branchName = ''
      this.form.branchNameKana = ''
    },
    initServiceList () {
      this.form.services = []
    },
    initCompanyAndBranchLabel () {
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
      this.view.companyLabel.en = this.view.companyDefaultLabel.en
      this.view.branchLabel.ja = this.view.branchDefaultLabel.ja
      this.view.branchLabel.en = this.view.branchDefaultLabel.en
    },
    changeGroupLarge (groupLargeId, companyInsNoFlg) {
      // サービス、会社および支社・支局または媒体を初期化
      this.initServiceList()
      this.initBranchList()
      this.initCompanyList()
      this.initCompanyAndBranchLabel()

      this.form.companyInsNoFlg = companyInsNoFlg
      this.form.groupSmallId = null
    },
    async changeGroupSmall (groupSmallId, companyInsNoFlg) {
      // サービス、会社および支社・支局または媒体を初期化
      this.initServiceList()
      this.initBranchList()
      this.initCompanyList()
      this.setCompanyAndBranchLabel(groupSmallId)

      // 会社情報を設定
      if (companyInsNoFlg === '0') {
        await this.getCompanyList(groupSmallId)
      }
    },
    setCompanyAndBranchLabel (groupSmallId) {
      const groupSmall = this.view.groupList
        .flatMap(groupLarge => groupLarge.groupSmallList)
        .find(groupSmall => groupSmall.groupSmallId === Number(groupSmallId))

      if (groupSmall === undefined) {
        this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
        this.view.companyLabel.en = this.view.companyDefaultLabel.en
        this.view.branchLabel.ja = this.view.branchDefaultLabel.ja
        this.view.branchLabel.en = this.view.branchDefaultLabel.en
      } else {
        this.view.companyLabel.ja = StringUtils.isEmpty(groupSmall.companyLabel.ja) ? this.view.companyDefaultLabel.ja : groupSmall.companyLabel.ja
        this.view.companyLabel.en = StringUtils.isEmpty(groupSmall.companyLabel.en) ? this.view.companyDefaultLabel.en : groupSmall.companyLabel.en
        this.view.branchLabel.ja = StringUtils.isEmpty(groupSmall.branchLabel.ja) ? this.view.branchDefaultLabel.ja : groupSmall.branchLabel.ja
        this.view.branchLabel.en = StringUtils.isEmpty(groupSmall.branchLabel.en) ? this.view.branchDefaultLabel.en : groupSmall.branchLabel.en
      }
    },
    getGroupSmallName (item) {
      // 小分類の選択肢の名前を多国語対応するためメソッドとして外だし
      return item.groupSmallName[i18n.locale]
    },
    getPrefName (item) {
      // 都道府県の選択肢の名前を多国語対応するためメソッドとして外だし
      return item.kbnVal[i18n.locale]
    },
    async getCompanyList (groupSmallId) {
      const addEtcFlg = this.view.groupList
        .flatMap(groupLarge => groupLarge.groupSmallList)
        .find(groupSmall => groupSmall.groupSmallId === Number(groupSmallId))
        .accountEntryAddCompanyFlg
      // 返却用のリスト準備
      this.view.companyList = [
        ...(await Common.companyList({ groupSmallId: groupSmallId })),
        ...(addEtcFlg === '1' ? [{ companyName: i18n.t('message.account.entry.select.other'), companyId: constantValue.otherCompanyId }] : [])]
    },
    changeCompany (companyId) {
      // 会社の一部と支社・支局または媒体を初期化
      this.form.companyName = ''
      this.form.companyNameKana = ''
      this.initBranchList()

      // 支社・支局または媒体の一覧をセット
      this.getBranchList(companyId)
    },
    async getBranchList (companyId) {
      // 返却用のリスト準備
      this.view.branchList = [
        ...(await Common.branchList({ companyId: companyId })),
        { branchName: i18n.t('message.account.entry.select.other'), branchId: constantValue.otherBranchId }
      ]
    },
    changeBranch (branchId) {
      // 支社・支局または媒体を初期化
      this.form.branchName = ''
      this.form.branchNameKana = ''
    },
    goLogin () {
      this.$router.push({ path: '/login' })
    },
    async beforeRegister () {
      if (this.form.id !== '') {
        // 入力内容確認ダイアログを表示
        this.dialog.inputConfirm = true
        return
      }
      await this.goRegister() // メールアドレス未入力ならAPIコールへ
    },
    async goRegister () {
      this.dialog.inputConfirm = false
      this.form.locale = this.$i18n.locale
      this.form.freelance = null
      this.form.localMedia = null
      if (this.isFreelance) {
        this.form.freelance = this.freelanceForm
      } else if (this.isNewLocalMedia) {
        this.form.localMedia = this.localMediaForm
      }
      await AccountEntry.register(this.form)
        .then(() => {
          this.dialog.entryComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.company.ja')
      this.view.companyLabel.en = this.view.companyDefaultLabel.en = this.getDefaultLabelFromList(list, 'label.default.company.en')
      this.view.branchLabel.ja = this.view.branchDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.branch.ja')
      this.view.branchLabel.en = this.view.branchDefaultLabel.en = this.getDefaultLabelFromList(list, 'label.default.branch.en')
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    },
    setErrMessageReplaceList () {
      this.errMessageReplaceList = [
        { param: 'companyId', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'companyName', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'companyNameKana', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'branchId', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchName', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchNameKana', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel }
      ]
    },
    async selectCompany (compnay) {
      this.form.groupLargeId = compnay.groupLargeId
      this.changeGroupLarge(compnay.groupLargeId, compnay.companyInsNoFlg)
      this.form.groupSmallId = compnay.groupSmallId
      await this.changeGroupSmall(compnay.groupSmallId, compnay.companyInsNoFlg)
      this.form.companyId = compnay.companyId
      this.changeCompany(compnay.companyId)
    },
    async freelanceFileUpload () {
      try {
        this.view.freelanceFileErrors = []
        const file = this.$refs.freelanceFile.files[0]

        if (!file) {
          return
        }

        const fileName = file.name
        const fileType = file.type

        if (file.size > 50 * 1024 * 1024) {
          this.view.freelanceFileErrors.push({
            param: 'freelance.uploadFiles',
            msg: 'sizeOver'
          })
          return
        }

        if (fileName.length > 100) {
          this.view.freelanceFileErrors.push({
            param: 'freelance.uploadFiles',
            msg: 'nameMaxLength'
          })
          return
        }

        const splited = fileName.split('.')
        if (splited.length < 2) {
          this.view.freelanceFileErrors.push({
            param: 'freelance.uploadFiles',
            msg: 'illegalExtension'
          })
          return
        }
        const uploadableExt = ['gif', 'jpg', 'jpeg', 'png', 'docx', 'pdf', 'pptx', 'txt', 'xlsx', 'zip']
        const extReg = new RegExp('^(' + uploadableExt.join('|') + ')$', 'i')
        if (!extReg.test(splited[splited.length - 1])) {
          this.view.freelanceFileErrors.push({
            param: 'freelance.uploadFiles',
            msg: 'illegalExtension'
          })
          return
        }

        const ret = await AccountEntry.entryFileUploadUrl()

        const filePath = ret.path
        const that = this

        store.dispatch('isLoading', true)
        axios.put(ret.url, file, {
          headers: {
            'content-type': fileType
          }
        }).then(function () {
          that.freelanceForm.uploadFiles.push({
            path: filePath,
            type: fileType,
            name: fileName
          })
        }).catch(function () {
          alert('File Upload Error')
        }).finally(function () {
          store.dispatch('isLoading', false)
        })
      } catch {
        alert('File Upload Error')
      }
    },
    freelanceFileDelete (file) {
      this.freelanceForm.uploadFiles = this.freelanceForm.uploadFiles.filter(_file => file !== _file)
    },
    getLocalMediaManagementClubName (item) {
      return item.kbnVal[i18n.locale]
    }
  },
  created: async function () {
    this.view.constantValue = constantValue
    this.view.groupList = await Common.groupListEntry()
    this.view.serviceList = await Common.serviceList()
    await this.setDefaultLabel()
    this.setErrMessageReplaceList()
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'IS_LANG_JA') {
        this.form.companyNameKana = ''
        this.form.branchNameKana = ''
        // 'その他'の選択肢を言語で切り替え
        const companyList = this.view.companyList.map(item => item.companyId === constantValue.otherCompanyId
          ? { companyName: i18n.t('message.account.entry.select.other'), companyId: item.companyId }
          : item
        )
        this.view.companyList = companyList
        const branchList = this.view.branchList.map(item => item.branchId === constantValue.otherBranchId
          ? { branchName: i18n.t('message.account.entry.select.other'), branchId: item.branchId }
          : item
        )
        this.view.branchList = branchList
      }
    })
  }
}
</script>

<style scoped>
/* deep selector で子コンポーネントの高さ制御 */
.v-messages {
  min-height: 0px !important;
}
.acceptTermsOfUse >>> .v-input__control{
  width: 28px;
  display: inline-block;
  flex-grow: unset;
  margin-top:-3px;
}
.acceptTermsOfUse >>> .v-input__append-outer {
  color:rgba(0, 0, 0, 0.87);
}
.fileName {
  display: inline-block;
  margin-right: 10px;
}
.fileDelete{
  display: inline-block;
  font-weight: 900;
  cursor: pointer;
}
.descIdContainer{
  padding: 10px 0;
}
.descId{
  color: red;
  margin: 0;
}
</style>
